import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { hasRole } from '../../auth/roles';
import { useTheme } from '../../theme/useTheme';
import { Card } from '../../components/ui/Card';
import { Spinner } from '../../components/ui/Spinner';
import '../auth/auth.css';
import './HomePage.css';

/**
 * Public landing — same standalone full-viewport shell as the login page. Signed-in users
 * never see it: they go straight to their working surface (dashboard for admins, booking
 * grid for coaches); ProtectedRoute picks up the status/MFA funnels from there.
 */
export function HomePage() {
  const { branding } = useTheme();
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="auth-shell">
        <Spinner center />
      </div>
    );
  }

  if (user) {
    return <Navigate to={hasRole(user.role, 'Admin') ? '/admin' : '/book'} replace />;
  }

  return (
    <div className="auth-shell">
      <div className="auth-brand">
        {branding?.logoUrl ? (
          <img src={branding.logoUrl} alt={branding.clubName} />
        ) : (
          <span className="auth-brand-name">{branding?.clubName ?? 'Coach Portal'}</span>
        )}
      </div>
      <Card className="auth-card">
        <p className="auth-welcome">Welcome to the coach portal</p>
        <p className="home-blurb">
          Book training slots, request match pitches and manage your team&apos;s bookings in one
          place.
        </p>
        <div className="home-actions">
          <Link to="/login" className="ui-btn ui-btn-primary ui-btn-md auth-full-width">
            Sign in
          </Link>
          <Link to="/register" className="ui-btn ui-btn-secondary ui-btn-md auth-full-width">
            Create a coach account
          </Link>
        </div>
      </Card>
      <p className="auth-copyright">
        © {new Date().getFullYear()} {branding?.clubName ?? 'Coach Portal'}
      </p>
    </div>
  );
}
